export const applicationEndpoints = 
{
    root: `/`,
    dashboard: `/dashboard`,

    annualworkgroupstatus_activityId: `/annualworkgroupstatus/:activityId`,
    annualworkgroupstatus: `/annualworkgroupstatus`,
 
    incidents_id: `/incidents/:id`,
    incidents: `/incidents`,
    public_incidents_siteId_id: `/public/incidents/:siteId/:id`,

    organization: `/organization`,
    
    portal_incidents_type: `/portal/incidents/:type`,
    portal_incidents: `/portal/incidents`,
    
    portal_login:`/portal/login`,
    portal_login_siteId: `/portal/login/:siteId`,
    portal_login_siteId_confirm_email_requestId: `/portal/login/:siteId/confirm/:email/:requestId`,
    portal_launch_siteId: `/portal/launch/:siteId`,
    
    portal_access_key_siteId_accessKey: `/portal/access-key/:siteId/:accessKey`,
    
    portal_logout: `/portal/logout`,

    portal_organization: `/portal/organization`,
    portal_links: `/portal/links`,
    portal_survey_reports: `/portal/reports`,
    portal_survey_report_portalResourceId: `/portal/reports/:portalResourceId`,
    portal_actionplans: `/portal/actionplans`,
    portal_files: `/portal/files`,
    
    portal: `/portal`,

    public_learning: `/public/learning`,
    public_learning_moduleId: `/public/learning/:moduleId`,
    public_article_siteId_articleId: `/public/articles/:siteId/:articleId`,

    settings: `/settings`,

    survy_key_surveyId_responseId_questions_questionIndex:   '/survy/:key/:surveyId/:responseId/questions/:questionIndex',
    survy_key_surveyId_responseId_finalize:                  '/survy/:key/:surveyId/:responseId/finalize',
    survy_key_surveyId_responseId_thanks:                    '/survy/:key/:surveyId/:responseId/thanks',
    survy_key_surveyId_responseId:                           '/survy/:key/:surveyId/:responseId',

    workplacesassessments_activityId:                       `/workplaceassessments/:activityId`,
    workplacesassessments:                                  `/workplaceassessments`,
};